import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { QUERY_PARAMS, ITCITenantComponentOptions, ITCIApplication, TCITenantAppType } from "@tci/common";

import { NgSubmenuLeftService } from "./ng-submenu-left.service";

import { Observable } from "rxjs";
import * as lodash from "lodash";

@Component({
    selector: "ng-submenu-left",
    templateUrl: "./ng-submenu-left.component.html",
    styleUrls: ["./ng-submenu-left.component.less"]
})
export class NgSubmenuLeftComponent implements OnInit, OnChanges {
    @Input() app: ITCIApplication;
    @Input() currentRoute: string;
    @Input() subRoute: string;
    @Input() className: string;

    menuItems: ITCITenantComponentOptions<any>[];

    constructor(
        private menuService: NgSubmenuLeftService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        // Build left-side menu
        this.menuItems = [];
        this.menuService.getMenuItems(this.currentRoute, this.app)
            .flatMap(items =>
                Observable.merge(...items.map(item =>
                    this.menuService.validateMenuItem(this.app, this.currentRoute, item.getRouteId())
                        .map(isValid => {
                            if (isValid) {
                                this.menuItems.push(item);
                            }
                        })
                ))
            )
            .toArray()
            .subscribe(() => this.validateSelectedMenuItem());
    }

    /**
     * The submenu state must always exist because a tab have to be
     * active all the time. If a tab is opened and the user opens a
     * HM item dialog the route get lost and the param become undefined.
     */
    ngOnChanges(changes: SimpleChanges) {
        if (this.menuItems && changes["subRoute"]) {
            if (this.subRoute) {
                this.validateSelectedMenuItem();
            } else {
                this.subRoute = changes["subRoute"].previousValue;
            }
        }
    }

    // Check if the current subRouteId is valid. If it's not then navigate to the first one available
    private validateSelectedMenuItem(): void {
        if (!this.menuItems.find(item => item.getRouteId() === this.subRoute)) {
            this.router.navigate(
                [{ submenuleft: lodash.first(this.menuItems).getRouteId() }],
                {
                    relativeTo: this.route,
                    preserveQueryParams: true,
                    replaceUrl: true
                }
            );
        }
    }
}
